<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-image</v-icon>
      <span class="title ml-2">Agregar imagen</span>
    </v-card-title>
    <v-card-text>
      <v-img v-if="imagen" height="300px" :src="imagen" class="mt-4">
        <div
          class="fill-height d-flex flex-column justify-center align-center"
          :style="{ background: hasFondo ? fondo : 'transparent' }"
        >
          <p
            class="display-2 font-weight-black"
            :class="[slide.is_claro ? 'white--text' : 'black--text']"
          >{{ slide.titulo }}</p>
          <p
            class="subtitle-1 font-weight-light my-1"
            :class="[slide.is_claro ? 'white--text' : 'black--text']"
          >{{ slide.subtitulo }}</p>
          <v-btn
            v-if="slide.link"
            :href="slide.link"
            target="_blank"
            outlined
            :class="[slide.is_claro ? 'white--text' : 'black--text']"
          >{{ slide.link_titulo }}</v-btn>
        </div>
      </v-img>
      <v-img v-else height="300px" class="grey mt-4"></v-img>
      <v-form ref="formAdd">
        <v-row>
          <v-col cols="12" sm="6">
            <v-file-input
              label="Imagen 1920X1280"
              v-model="imageFile"
              @change="onFileChange()"
              accept="image/*"
              :error-messages="errImagen"
            ></v-file-input>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Título"
              v-model="slide.titulo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Subtítulo"
              v-model="slide.subtitulo"
            ></v-text-field>
            <v-switch v-model="slide.is_claro" color="primary" label="Texto claro"></v-switch>
            <v-text-field
              label="Link URL"
              v-model="slide.link"
              :error-messages="errLink"
            ></v-text-field>
            <v-text-field
              label="Título del link"
              v-model="slide.link_titulo"
              :error-messages="errLinkTitulo"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-switch
              v-model="hasFondo"
              color="primary"
              label="Color de fondo"
            ></v-switch>
            <v-color-picker
              v-model="fondo"
              mode="rgba"
              hide-canvas
              :disabled="!hasFondo"
            ></v-color-picker>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer />
      <v-btn color="primary" @click="insertSlide()" :loading="loading">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, requiredIf, url } from 'vuelidate/lib/validators'
import { fileSize } from '../plugins/vuelidate'
export default {
  data () {
    return {
      slide: {
        titulo: '',
        subtitulo: '',
        is_claro: true,
        link: ''
      },
      fondo: '',
      hasFondo: false,
      imageFile: null,
      imagen: null,
      loading: false
    }
  },
  computed: {
    errImagen () {
      const errs = []
      if (!this.$v.imageFile.$dirty) return errs
      !this.$v.imageFile.required && errs.push('La imagen es requerida')
      !this.$v.imageFile.fileSize && errs.push('El tamaño maximo de la images es de 2MB')
      return errs
    },
    errLink () {
      const errs = []
      if (!this.$v.slide.link.$dirty) return errs
      !this.$v.slide.link.url && errs.push('El link es invalido')
      return errs
    },
    errLinkTitulo () {
      const errs = []
      if (!this.$v.slide.link_titulo.$dirty) return errs
      !this.$v.slide.link_titulo.required && errs.push('El titulo del link es requerido')
      return errs
    }
  },
  methods: {
    onFileChange () {
      if (this.imageFile) {
        this.imagen = URL.createObjectURL(this.imageFile)
      }
    },
    async insertSlide () {
      this.$v.imageFile.$touch()
      this.$v.slide.$touch()
      if (!this.$v.imageFile.$invalid && !this.$v.slide.$invalid) {
        try {
          this.loading = true
          const config = {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
          const formData = new FormData()
          const data = {
            ...this.slide,
            fondo: this.hasFondo ? this.fondo : null
          }
          formData.append('data', JSON.stringify(data))
          formData.append('files.imagen', this.imageFile, this.imageFile.name)
          await this.$http.slides.post('', formData, config)
          this.slide = {
            titulo: '',
            subtitulo: '',
            is_claro: true
          }
          this.imagen = null
          this.imageFile = null
          this.hasFondo = false
          this.loading = false
          this.$emit('saved')
        } catch (error) {
          this.loading = false
          window.alert('😓 Ha ocurrido un error al guardar los datos')
        }
      }
    }
  },
  validations: {
    slide: {
      link: { url },
      link_titulo: {
        required: requiredIf(model => !!model.link)
      }
    },
    imageFile: {
      required,
      fileSize: fileSize(2048)
    }
  }
}
</script>
